export default __webpack_public_path__ + "static/media/tituloES.430e64da.png";